/* eslint-disable @typescript-eslint/no-non-null-assertion */
import { FileType } from '@office-start/document-types';
import EdgeworthIcon from '@office-start/edgeworth-icon';
import classNames from 'classnames';
import React from 'react';
import styles from '../views/BaseEdgeworthControl.module.scss';
export var FileFilterKey;
(function (FileFilterKey) {
    FileFilterKey["word"] = "Word Filter";
    FileFilterKey["excel"] = "Excel Filter";
    FileFilterKey["powerpoint"] = "PowerPoint Filter";
    FileFilterKey["forms"] = "Forms Filter";
    FileFilterKey["onenote"] = "OneNote Filter";
    FileFilterKey["visio"] = "Visio Filter";
    FileFilterKey["fluid"] = "Fluid Filter";
    FileFilterKey["sway"] = "Sway Filter";
    FileFilterKey["clipchamp"] = "Clipchamp Filter";
    FileFilterKey["powerbi"] = "PowerBI Filter";
    FileFilterKey["drafts"] = "Drafts Filter";
    FileFilterKey["pdf"] = "PDF Filter";
    FileFilterKey["meeting"] = "Meeting Filter";
    FileFilterKey["image"] = "Image Filter";
    FileFilterKey["video"] = "Video Filter";
    FileFilterKey["whiteboard"] = "Whiteboard Filter";
    FileFilterKey["designer"] = "Designer Filter";
    FileFilterKey["link"] = "Link Filter";
    FileFilterKey["other"] = "Other Filter";
})(FileFilterKey || (FileFilterKey = {}));
export var RecognizedFileTypes = new Set([
    FileType.Word,
    FileType.Excel,
    FileType.PowerPoint,
    FileType.PowerBI,
    FileType.Forms,
    FileType.FormsQuiz,
    FileType.OneNote,
    FileType.MeetingNotes,
    FileType.OneNotePage,
    FileType.OneNoteClassNoteBook,
    FileType.Visio,
    FileType.Pdf,
    FileType.Fluid,
    FileType.MeetingObject,
    FileType.Stream,
    FileType.PlayList,
    FileType.PlayLists,
    FileType.ScreenRecording,
    FileType.Image,
    FileType.Photos,
    FileType.Whiteboard,
    FileType.Designer,
    FileType.Sway,
    FileType.Clipchamp,
]);
export var SupportedStartPageFileTypes = new Set([
    FileType.Word,
    FileType.Excel,
    FileType.PowerPoint,
    FileType.Visio,
    FileType.Fluid,
    FileType.Whiteboard,
    FileType.Clipchamp,
]);
export var FileTypeToFilterFunctionMap = new Map([
    [
        FileType.Word,
        function (doc) { return !!doc.fileType && doc.fileType === FileType.Word; },
    ],
    [
        FileType.Excel,
        function (doc) { return !!doc.fileType && doc.fileType === FileType.Excel; },
    ],
    [
        FileType.PowerPoint,
        function (doc) {
            return !!doc.fileType && doc.fileType === FileType.PowerPoint;
        },
    ],
    [
        FileType.Forms,
        function (doc) {
            return !!doc.fileType &&
                (doc.fileType === FileType.Forms ||
                    doc.fileType === FileType.FormsQuiz);
        },
    ],
    [
        FileType.OneNote,
        function (doc) {
            return !!doc.fileType &&
                (doc.fileType === FileType.OneNote ||
                    doc.fileType === FileType.OneNotePage ||
                    doc.fileType === FileType.OneNoteClassNoteBook);
        },
    ],
    [
        FileType.Visio,
        function (doc) { return !!doc.fileType && doc.fileType === FileType.Visio; },
    ],
    [
        FileType.Sway,
        function (doc) { return !!doc.fileType && doc.fileType === FileType.Sway; },
    ],
    [
        FileType.Pdf,
        function (doc) { return !!doc.fileType && doc.fileType === FileType.Pdf; },
    ],
    [
        FileType.Fluid,
        function (doc) {
            return !!doc.fileType &&
                (doc.fileType === FileType.Fluid ||
                    doc.fileType === FileType.MeetingNotes);
        },
    ],
    [
        FileType.Draft,
        function (doc) { return !!doc.fileType && doc.fileType === FileType.Draft; },
    ],
    [
        FileType.MeetingObject,
        function (doc) {
            return !!doc.fileType && doc.fileType === FileType.MeetingObject;
        },
    ],
    [
        FileType.Stream,
        function (doc) {
            return !!doc.fileType &&
                (doc.fileType === FileType.Stream ||
                    doc.fileType === FileType.PlayLists ||
                    doc.fileType === FileType.PlayList ||
                    doc.fileType === FileType.ScreenRecording) &&
                !!doc.sharepointIds;
        },
    ],
    [
        FileType.Image,
        function (doc) { return !!doc.fileType && doc.fileType === FileType.Image; },
    ],
    [FileType.Link, function (doc) { return doc.fileType === FileType.Link; }],
    [
        FileType.Whiteboard,
        function (doc) {
            return !!doc.fileType && doc.fileType === FileType.Whiteboard;
        },
    ],
    [
        FileType.Designer,
        function (doc) { return !!doc.fileType && doc.fileType === FileType.Designer; },
    ],
    [
        FileType.Clipchamp,
        function (doc) {
            return !!doc.fileType && doc.fileType === FileType.Clipchamp;
        },
    ],
    [
        FileType.PowerBI,
        function (doc) {
            return !!doc.fileType && doc.fileType === FileType.MicrosoftPowerBI;
        },
    ],
]);
export var FileFiltersMap = new Map([
    [FileFilterKey.word, FileTypeToFilterFunctionMap.get(FileType.Word)],
    [FileFilterKey.excel, FileTypeToFilterFunctionMap.get(FileType.Excel)],
    [
        FileFilterKey.powerpoint,
        FileTypeToFilterFunctionMap.get(FileType.PowerPoint),
    ],
    [FileFilterKey.forms, FileTypeToFilterFunctionMap.get(FileType.Forms)],
    [FileFilterKey.visio, FileTypeToFilterFunctionMap.get(FileType.Visio)],
    [FileFilterKey.fluid, FileTypeToFilterFunctionMap.get(FileType.Fluid)],
    [FileFilterKey.drafts, FileTypeToFilterFunctionMap.get(FileType.Draft)],
    [FileFilterKey.onenote, FileTypeToFilterFunctionMap.get(FileType.OneNote)],
    [
        FileFilterKey.meeting,
        FileTypeToFilterFunctionMap.get(FileType.MeetingObject),
    ],
    [FileFilterKey.pdf, FileTypeToFilterFunctionMap.get(FileType.Pdf)],
    [FileFilterKey.link, FileTypeToFilterFunctionMap.get(FileType.Link)],
    [
        FileFilterKey.image,
        function (doc) {
            return !!doc.fileType &&
                (doc.fileType === FileType.Image ||
                    doc.fileType === FileType.Photos);
        },
    ],
    [FileFilterKey.video, FileTypeToFilterFunctionMap.get(FileType.Stream)],
    [
        FileFilterKey.whiteboard,
        FileTypeToFilterFunctionMap.get(FileType.Whiteboard),
    ],
    [FileFilterKey.sway, FileTypeToFilterFunctionMap.get(FileType.Sway)],
    [
        FileFilterKey.clipchamp,
        FileTypeToFilterFunctionMap.get(FileType.Clipchamp),
    ],
    [FileFilterKey.powerbi, FileTypeToFilterFunctionMap.get(FileType.PowerBI)],
    [
        FileFilterKey.other,
        function (doc) {
            return !!doc.fileType && !RecognizedFileTypes.has(doc.fileType);
        },
    ],
]);
// TODO: Refactor this and FileFiltersMap to a utility function
export var ConsumerFileFiltersMap = new Map([
    [FileFilterKey.word, FileTypeToFilterFunctionMap.get(FileType.Word)],
    [FileFilterKey.excel, FileTypeToFilterFunctionMap.get(FileType.Excel)],
    [
        FileFilterKey.powerpoint,
        FileTypeToFilterFunctionMap.get(FileType.PowerPoint),
    ],
    [FileFilterKey.forms, FileTypeToFilterFunctionMap.get(FileType.Forms)],
    [
        FileFilterKey.designer,
        FileTypeToFilterFunctionMap.get(FileType.Designer),
    ],
    [FileFilterKey.onenote, FileTypeToFilterFunctionMap.get(FileType.OneNote)],
    [FileFilterKey.sway, FileTypeToFilterFunctionMap.get(FileType.Sway)],
    [FileFilterKey.pdf, FileTypeToFilterFunctionMap.get(FileType.Pdf)],
    // TODO: Revisit when images and photos are supported in Consumer
    // [
    //     FileFilterKey.image,
    //     (doc: Document) =>
    //         !!doc.fileType &&
    //         (doc.fileType === FileType.Image ||
    //             doc.fileType === FileType.Photos),
    // ],
    // [FileFilterKey.video, FileTypeToFilterFunctionMap.get(FileType.Stream)!],
    [FileFilterKey.link, FileTypeToFilterFunctionMap.get(FileType.Link)],
    [
        FileFilterKey.other,
        function (doc) {
            return !!doc.fileType && !RecognizedFileTypes.has(doc.fileType);
        },
    ],
]);
export var FileFilterToIconMap = new Map([
    [
        FileFilterKey.word,
        React.createElement("div", { key: FileFilterKey.word, className: "ms-ohp-svg-Icon ms-ohp-Icon--wordLogo" }),
    ],
    [
        FileFilterKey.excel,
        React.createElement("div", { key: FileFilterKey.excel, className: "ms-ohp-svg-Icon ms-ohp-Icon--excelLogo" }),
    ],
    [
        FileFilterKey.powerpoint,
        React.createElement("div", { key: FileFilterKey.powerpoint, className: "ms-ohp-svg-Icon ms-ohp-Icon--powerpointLogo" }),
    ],
    [
        FileFilterKey.forms,
        React.createElement("span", { key: FileFilterKey.forms, className: "ms-ohp-svg-Icon ms-ohp-Icon--formsLogo" }),
    ],
    [
        FileFilterKey.onenote,
        React.createElement("div", { key: FileFilterKey.onenote, className: "ms-ohp-svg-Icon ms-ohp-Icon--onenoteLogo" }),
    ],
    [
        FileFilterKey.visio,
        React.createElement("div", { key: FileFilterKey.visio, className: "ms-ohp-svg-Icon ms-ohp-Icon--visioLogo" }),
    ],
    [
        FileFilterKey.fluid,
        React.createElement("div", { key: FileFilterKey.fluid, className: classNames('ms-ohp-svg-Icon ms-ohp-Icon--fluidLogo', styles['fluid-icon']) }),
    ],
    [
        FileFilterKey.drafts,
        React.createElement("div", { key: FileFilterKey.drafts },
            React.createElement(EdgeworthIcon, { iconName: "NotepadIcon" })),
    ],
    [
        FileFilterKey.sway,
        React.createElement("div", { key: FileFilterKey.sway, className: "ms-ohp-svg-Icon ms-ohp-Icon--swayLogo" }),
    ],
    [
        FileFilterKey.pdf,
        React.createElement("div", { key: FileFilterKey.pdf },
            React.createElement(EdgeworthIcon, { iconName: "PdfIcon" })),
    ],
    [
        FileFilterKey.meeting,
        React.createElement("div", { key: FileFilterKey.meeting },
            React.createElement(EdgeworthIcon, { iconName: "CalendarIcon" })),
    ],
    [
        FileFilterKey.link,
        React.createElement("div", { key: FileFilterKey.link },
            React.createElement(EdgeworthIcon, { iconName: "GlobeIcon" })),
    ],
    [
        FileFilterKey.image,
        React.createElement("div", { key: FileFilterKey.image },
            React.createElement(EdgeworthIcon, { iconName: "ImageIcon" })),
    ],
    [
        FileFilterKey.video,
        React.createElement("div", { key: FileFilterKey.video },
            React.createElement(EdgeworthIcon, { iconName: "VideoIcon" })),
    ],
    [
        FileFilterKey.whiteboard,
        React.createElement("div", { key: FileFilterKey.whiteboard },
            React.createElement(EdgeworthIcon, { iconName: "WhiteboardIcon" })),
    ],
    [
        FileFilterKey.designer,
        React.createElement("div", { key: FileFilterKey.designer, className: "ms-ohp-svg-Icon ms-ohp-Icon--designerLogo" }),
    ],
    [
        FileFilterKey.clipchamp,
        React.createElement("div", { key: FileFilterKey.clipchamp, className: "ms-ohp-svg-Icon ms-ohp-Icon--clipchampLogo" }),
    ],
    [
        FileFilterKey.powerbi,
        React.createElement("div", { key: FileFilterKey.powerbi, className: "ms-ohp-svg-Icon ms-ohp-Icon--powerBILogo", style: { height: '20px', width: '20px' } }),
    ],
    [
        FileFilterKey.other,
        React.createElement("div", { key: FileFilterKey.other },
            React.createElement(EdgeworthIcon, { iconName: "DocumentIcon" })),
    ],
]);
// Contains filled icons only for icons found in the @fluentui/react-icons set
export var FileFilterToFilledIconMap = new Map([
    [
        FileFilterKey.drafts,
        React.createElement("div", { key: FileFilterKey.drafts },
            React.createElement(EdgeworthIcon, { iconName: "NotepadIcon", filled: true })),
    ],
    [
        FileFilterKey.pdf,
        React.createElement("div", { key: FileFilterKey.pdf },
            React.createElement(EdgeworthIcon, { iconName: "PdfIcon", filled: true })),
    ],
    [
        FileFilterKey.meeting,
        React.createElement("div", { key: FileFilterKey.meeting },
            React.createElement(EdgeworthIcon, { iconName: "CalendarIcon", filled: true })),
    ],
    [
        FileFilterKey.image,
        React.createElement("div", { key: FileFilterKey.image },
            React.createElement(EdgeworthIcon, { iconName: "ImageIcon", filled: true })),
    ],
    [
        FileFilterKey.video,
        React.createElement("div", { key: FileFilterKey.video },
            React.createElement(EdgeworthIcon, { iconName: "VideoIcon", filled: true })),
    ],
    [
        FileFilterKey.whiteboard,
        React.createElement("div", { key: FileFilterKey.whiteboard },
            React.createElement(EdgeworthIcon, { iconName: "WhiteboardIcon", filled: true })),
    ],
    [
        FileFilterKey.other,
        React.createElement("div", { key: FileFilterKey.other },
            React.createElement(EdgeworthIcon, { iconName: "DocumentIcon", filled: true })),
    ],
]);
//# sourceMappingURL=FileFilters.js.map